import { type FC, useState } from "react";
import { TextButton } from "@root/shared/components/TextButton";
import { Icon } from "@root/shared/components/Icon";
import { colors } from "@root/shared/styles/sprinkles.css";
import { UserHiddenConfirmationModal } from "@clientFrontend/features/scout/components/UserHiddenConfirmationModal";
import type { UserHiddenButtonContent } from "@clientFrontend/features/scout/types/userHidden";
import * as styles from "./styles.css";

type Props = UserHiddenButtonContent;

export const ResultUserControlButton: FC<Props> = ({
  isHidden,
  isLoading,
  onClickUserHiddenTrigger,
}) => {
  const [isShowTooltip, setIsShowTooltip] = useState(false);
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);

  const showTooltip = () => {
    setIsShowTooltip(true);
  };

  const hideTooltip = () => {
    setIsShowTooltip(false);
  };

  const onClickUserHiddenButton = () => {
    if (isHidden && onClickUserHiddenTrigger) {
      // 非表示ユーザーの場合、確認モーダルを出さずに解除リクエストを送る
      onClickUserHiddenTrigger();
    } else {
      // 非表示ではないユーザーの場合、確認モーダルを出す
      setIsShowConfirmModal(true);
    }
  };

  // 非表示確認モーダルで「はい」を押下した際に発火
  const onClickConfirmedButton = () => {
    setIsShowConfirmModal(false);
    if (onClickUserHiddenTrigger) {
      // 非表示にするリクエストを送る
      onClickUserHiddenTrigger();
    }
  };

  return (
    <div className={styles.wrapper}>
      <TextButton
        className={isLoading ? styles.loadingButton : styles.button}
        onClick={onClickUserHiddenButton}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        size="small"
        disabled={isLoading}
      >
        <Icon name="human-minus" fontSize="20px" />
        {!isHidden ? <p>この求職者を非表示にする</p> : <p>非表示を解除する</p>}
      </TextButton>
      {!isLoading && isShowTooltip && (
        <div className={styles.toolTip}>
          <p className={styles.toolTipIconWrapper}>
            <Icon name="human-minus" color={colors.Orange} fontSize="24px" />
          </p>
          <p>
            {!isHidden ? (
              <>
                検索結果に表示したくない求職者を
                <br />
                非表示にできます
              </>
            ) : (
              <>
                解除すると、
                <br />
                一覧に表示されるようになります
              </>
            )}
          </p>
        </div>
      )}
      {isShowConfirmModal && (
        <UserHiddenConfirmationModal
          isShow={isShowConfirmModal}
          onClickModalClose={() => setIsShowConfirmModal(false)}
          onClickUserHiddenTrigger={() => onClickConfirmedButton()}
        />
      )}
    </div>
  );
};
